import AthubCloudApi from '@/api/athubCloud/index'
import { from } from 'rxjs';

export default {

    namespaced: true,

    state: {

        deptSource$: {}

    },

    getters: {

        deptSource$(state) {
            return state.deptSource$;
        },

    },

    mutations: {
        setDeptSource(state, payload) {
            state.deptSource$ = payload;
        },

    },

    actions: {

        getDeptSource({commit}, payload) {
            commit("setDeptSource", from(AthubCloudApi.fetchDeptListByAuthSites()));
        }

    },

}